import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { CommonService } from './common.service';

@Injectable({
	providedIn: 'root',
})
export class HearingOfficeAuthGuard {
	constructor(
		private cmnServ: CommonService,
		private router: Router
	) {}

	canActivate(
		next: ActivatedRouteSnapshot,
		state: RouterStateSnapshot
	): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
		// Check if user has required roles in hearing offices (830, 831, 832, 833) for new complaints
		if (this.cmnServ.hasNewComplaintAccess() || this.cmnServ.isHearingAdmin()) {
			return true;
		} else {
			// Redirect to dashboard if user doesn't have required hearing roles for new complaints
			console.warn('User does not have required roles for new complaints. Must have one of: HearingSupervisorAdminJudge, HearingAdmin, or HearingDivisionDirector in offices 830, 831, 832, or 833. Redirecting to dashboard.');
			return this.router.createUrlTree(['/dashboard']);
		}
	}
}
